import React, { ComponentType } from "react"
import { compose } from "@reduxjs/toolkit"

import { withDebts } from "hocs/features"
import CardUnsolved from "components/Debt/CardUnsolved"
import CardDraftSentToSelfService from "components/Debt/CardDraftSentToSelfService"
import CardDraftPaymentSchedule from "components/Debt/CardDraftPaymentSchedule"
import CardPaymentSchedule from "components/Debt/CardPaymentSchedule"
import CardOverdue from "components/Debt/CardOverdue"
import CardCourtPreparing from "components/Debt/CardCourtPreparing"
import CardCourt from "components/Debt/CardCourt"
import CardBailiff from "components/Debt/CardBailiff"
import CardPaid from "components/Debt/CardPaid"
import CardEnded from "components/Debt/CardEnded"
import { DebtType, DebtsCollectionType } from "types"

type Props = {
  debts: DebtsCollectionType
}

const List = ({ debts }: Props) => {
  const {
    unsolved,
    draft_sent_to_self_service,
    draft,
    active,
    overdue,
    court_preparing,
    court,
    bailiff,
    paid,
    ended,
  } = debts

  return (
    <div data-testid="debts-list">
      {(unsolved || []).map((item: DebtType) => (
        <CardUnsolved key={item.id} item={item} />
      ))}
      {(draft_sent_to_self_service || []).map((item: DebtType) => (
        <CardDraftSentToSelfService key={item.id} item={item} />
      ))}
      {(draft || []).map((item: DebtType) => (
        <CardDraftPaymentSchedule key={item.id} item={item} />
      ))}
      {(active || []).map((item: DebtType) => (
        <CardPaymentSchedule key={item.id} item={item} />
      ))}
      {(overdue || []).map((item: DebtType) => (
        <CardOverdue key={item.id} item={item} />
      ))}
      {(court_preparing || []).map((item: DebtType) => (
        <CardCourtPreparing key={item.id} item={item} />
      ))}
      {(court || []).map((item: DebtType) => (
        <CardCourt key={item.id} item={item} />
      ))}
      {(bailiff || []).map((item: DebtType) => (
        <CardBailiff key={item.id} item={item} />
      ))}
      {(paid || []).map((item: DebtType) => (
        <CardPaid key={item.id} item={item} />
      ))}
      {(ended || []).map((item: DebtType) => (
        <CardEnded key={item.id} item={item} />
      ))}
    </div>
  )
}

export default compose<ComponentType>(withDebts)(List)
